import React from 'react';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      <div className="about-hero">
        <h1>About Irish Visa Tracker</h1>
        <p className="about-subtitle">
          Empowering Indian visa applicants with instant notifications and real-time tracking for Ireland visa decisions
        </p>
      </div>

      <div className="mission-section">
        <div className="mission-card">
          <div className="mission-icon">🎯</div>
          <h2>Our Mission</h2>
          <p>
            We're on a mission to eliminate the stress and uncertainty of waiting for visa decisions. 
            Every day, thousands of Indian applicants anxiously refresh the Irish immigration website 
            multiple times, hoping to catch their decision the moment it's published. We automate this 
            process, delivering instant alerts so you can focus on what matters most—preparing for your journey.
          </p>
        </div>
      </div>

      <div className="stats-section">
        <h2>Impact by Numbers</h2>
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-number">15,482+</div>
            <div className="stat-label">Visa Decisions Tracked</div>
            <div className="stat-detail">Monitoring daily since 2024</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">2 min</div>
            <div className="stat-label">Average Alert Speed</div>
            <div className="stat-detail">Faster than manual checking</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">Live</div>
            <div className="stat-label">Decision outcomes</div>
            <div className="stat-detail">Observed in the tracked dataset</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">100%</div>
            <div className="stat-label">Data Privacy</div>
            <div className="stat-detail">Your information is secure</div>
          </div>
        </div>
      </div>

      <div className="values-section">
        <h2>Our Values</h2>
        <div className="values-grid">
          <div className="value-card">
            <div className="value-icon">⚡</div>
            <h3>Speed & Reliability</h3>
            <p>
              We monitor official NDVO decisions 24/7 and send instant notifications 
              within minutes of publication. No delays, no missed updates.
            </p>
          </div>
          <div className="value-card">
            <div className="value-icon">🔒</div>
            <h3>Privacy First</h3>
            <p>
              Your data is sacred. We only collect what's necessary and never 
              share your information with third parties. Complete transparency.
            </p>
          </div>
          <div className="value-card">
            <div className="value-icon">💰</div>
            <h3>Affordable Access</h3>
            <p>
              Premium features for just ₹349 one-time. No subscriptions, no hidden 
              fees. Everyone deserves access to instant alerts.
            </p>
          </div>
          <div className="value-card">
            <div className="value-icon">🤝</div>
            <h3>Support & Care</h3>
            <p>
              We're here for you every step of the way. Quick responses, helpful 
              guidance, and genuine care for your visa journey.
            </p>
          </div>
        </div>
      </div>

      <div className="story-section">
        <h2>Our Story</h2>
        <div className="story-content">
          <p>
            Irish Visa Tracker was born from personal experience. Like many of you, we've felt 
            the anxiety of waiting for a visa decision—refreshing the immigration website dozens 
            of times a day, losing sleep over uncertainty, and missing the exact moment when our 
            application was decided.
          </p>
          <p>
            We knew there had to be a better way. That's why we built this platform—to give every 
            Indian applicant the peace of mind that comes with instant notifications. Today, we're 
            proud to serve thousands of visa applicants, helping them stay informed without the stress.
          </p>
          <p>
            Built by <a href="https://selfdriven.careers" target="_blank" rel="noopener noreferrer">SelfDriven Careers</a>, 
            we're a remote-first team based in India, dedicated to creating tools that make 
            immigration journeys easier and less stressful.
          </p>
        </div>
      </div>

      <div className="transparency-section">
        <h2>Transparency & Trust</h2>
        <div className="transparency-grid">
          <div className="transparency-card">
            <h4>🏛️ Official Data Source</h4>
            <p>
              We use publicly available data from the official Irish Immigration (NDVO) 
              decisions published at immigration.ie. We are not affiliated with the 
              Government of Ireland.
            </p>
          </div>
          <div className="transparency-card">
            <h4>📊 Accurate Tracking</h4>
            <p>
              Our processing time estimates are indicative planning ranges based on
              historical category averages. They are not official deadlines or guarantees.
            </p>
          </div>
          <div className="transparency-card">
            <h4>🛡️ Security Standards</h4>
            <p>
              Industry-standard encryption, secure payment processing, and strict data 
              protection policies. Your information is always safe with us.
            </p>
          </div>
          <div className="transparency-card">
            <h4>💚 Community Driven</h4>
            <p>
              Built for Indian visa applicants, by people who understand your journey. 
              Your feedback shapes our product roadmap.
            </p>
          </div>
        </div>
      </div>

      <div className="about-cta">
        <h2>Ready to Track Your Visa?</h2>
        <p>Join thousands of applicants who never miss their decision moment</p>
        <a href="/" className="btn-primary">
          Start Tracking Now →
        </a>
      </div>
    </div>
  );
};

export default AboutPage;
